import { createReducer, on } from "@ngrx/store";
import { TaxType } from "../model/tax.model";
import { loadTaxType, loadTaxTypeSuccess } from "./tax.action";

export interface TaxTypeState {
  taxTypes: TaxType[], // ✅ ARRAY
  loading: boolean
}

export const initialTaxTypeState: TaxTypeState = {
  taxTypes: [], // ✅ ARRAY
  loading: false
}

export const taxTypeReducer = createReducer(
  initialTaxTypeState,
  on(loadTaxType, state => ({
    ...state,
    loading: true
  })),
  // When success occurs and we receive the apiKey
  on(loadTaxTypeSuccess, (state, { taxType }) => ({
    ...state,
    taxTypes: normalizeTaxTypes(taxType),
    loading: false
  }))
)

// The API's actual response shape doesn't always match TaxType[] at runtime
// (e.g. an object map instead of an array), so guard defensively even though
// the action's props type claims it's already TaxType[].
function normalizeTaxTypes(taxType: unknown): TaxType[] {
  if (Array.isArray(taxType)) {
    return taxType as TaxType[];
  }
  if (taxType && typeof taxType === 'object') {
    return Object.values(taxType as Record<string, unknown>) as TaxType[];
  }
  return [];
}